import EachDerivedLevels, {
  derivedLevelsWrapperPropTypes,
  derivedLevelsWrapperDefaults,
} from "./EachDerivedLevels";

// Config sobre EachDerivedLevels (auditoria 2026-07-17, item 1d)
class EachTironeLevels extends EachDerivedLevels {}

// Terços: 66.67% e 33.33% do intervalo highest–lowest
EachTironeLevels.computeMidLevels = ({ highest, lowest }) => ({
  upper: (2 * highest + lowest) / 3, // Upper third (66.67%)
  lower: (highest + 2 * lowest) / 3, // Lower third (33.33%)
});

EachTironeLevels.propTypes = derivedLevelsWrapperPropTypes;
EachTironeLevels.defaultProps = derivedLevelsWrapperDefaults;

export default EachTironeLevels;
